import React from 'react';
import './App.css';
import { Toaster } from './components/ui/toaster';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RouteSEO } from './components/RouteSEO';
import NotFound from './components/NotFound';
import CGU from './components/CGU';
import CGV from './components/CGV';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import USPs from './components/USPs';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import AdditionalServices from './components/AdditionalServices';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import Footer from './components/Footer';
import Paiement from './components/Paiement';
import Commander from './components/Commander';
import ConfirmationPaiement from './components/ConfirmationPaiement';
import Inscription from './components/Inscription';
import Connexion from './components/Connexion';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import MonCompte from './components/MonCompte';
import AdminDashboard from './components/AdminDashboard';
import PaiementSuccess from './components/PaiementSuccess';
import Profil from './components/Profil';
import ClientDashboard from './components/ClientDashboard';
import CommanderSansCompte from './components/CommanderSansCompte';
import DepartementPage from './components/DepartementPage';
import ZonesIntervention from './components/ZonesIntervention';
import NotreExperience from './components/NotreExperience';
import BenneChooser from './components/BenneChooser';
import { useScrollToHash } from './components/AnchorLink';
import { DEPARTEMENTS } from './data/departements';

const HomePage = () => {
  useScrollToHash();
  return (
    <>
      <Hero />
      <Services />
      <BenneChooser />
      <USPs />
      <NotreExperience />
      <HowItWorks />
      <ZonesIntervention />
      <Testimonials />
      <FAQ />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteSEO />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/inscription" element={<Inscription />} />
            <Route path="/connexion" element={<Connexion />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/mon-compte" element={<MonCompte />} />
            <Route path="/dashboard" element={<ClientDashboard />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/commander" element={<Commander />} />
            <Route path="/commander-sans-compte" element={<CommanderSansCompte />} />
            <Route path="/paiement/success" element={<PaiementSuccess />} />
            <Route path="/paiement/:devisId" element={<Paiement />} />
            <Route path="/confirmation-paiement/:devisId" element={<ConfirmationPaiement />} />
            {DEPARTEMENTS.map((d) => (
              <Route key={d.code} path={d.path} element={<DepartementPage dept={d} />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;